import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import P2 from '@base/P2/P2';
import Image from '@base/Image';
import { useRef, useState } from 'react';
import useDoubtConfig from '@api/hooks/goal/custom-doubts/useDoubtConfig';
import { getImage } from '@utils/imageHelper';
import useDarkModeStatus from '@stores/useDarkModeStatus';
import { getIsDarkModeOn } from '@stores/selectors/darkModeStatusSelectors';
import ImageUploadDailog from './SubmitDoubt/ImageUploadDailog'; // incomplete
import 'cropperjs/dist/cropper.css';
import { dialogImage } from '../DoubtSolution/CommonComponents';
import ImageSizeLimitDialog from './ImageSizeLimitDialog';

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    justify-content: space-evenly;
  }
`;

const StyInput = styled.input`
  display: none;
`;

const ErrorWrapper = styled.div`
  grid-column: span 10;
  display: flex;
  align-items: center;
  margin: ${Spacings.SPACING_4B} 0px;
`;

const UploadMsg = styled(P2)`
  margin-left: ${Spacings.SPACING_2B};
  color: var(--color-i-red);
`;

const UploadButton = styled.img`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};
  transition: opacity 0.3s ease;
`;

const UnAIDoubtImageUpload = ({
  goalUID,
  isUploadDisabled,
  setUploadedImageUrl,
  setSignedUrl
}) => {
  const {
    doubtConfigData: { maxAttachmentSizeInKB, isASDEnabled }
  } = useDoubtConfig(goalUID);
  const [cropImgSrc, setCropImgSrc] = useState(null);
  const [isCropDialogOpen, setCropDialogOpen] = useState(null);
  const [rotate, setImageRotate] = useState(0);
  const [cropper, setCropper] = useState(null);
  const [fileObj, setFileObject] = useState(null);
  const [isUploading, setIsUploading] = useState(null);
  const [error, setError] = useState(null);
  const hiddenFileInput = useRef(null);
  const [showImageSizeErrorDialog, setShowImageSizeErrorDialog] =
    useState(false);

  const uploadHandleClick = () => {
    setUploadedImageUrl('');

    setError('');
    hiddenFileInput.current.click();
  };

  const onImageSizeErrorDailogClose = () => {
    setShowImageSizeErrorDialog(false);
  };

  const onChange = (e) => {
    e.preventDefault();
    let files;

    if (e.target.files.length > 0) {
      files = e.target.files;
    }
    const { size, name } = files[0];
    const imageSizeInKB = size / 1000;

    // Get file extension
    const fileExtension = name.split('.').pop().toLowerCase();

    // Allow only png and jpeg, reject jpg
    if (fileExtension !== 'png' && fileExtension !== 'jpeg') {
      setError('Only .png and .jpeg files are allowed.');
      e.target.value = '';
      return;
    }
    if (imageSizeInKB > maxAttachmentSizeInKB) {
      setShowImageSizeErrorDialog(true);
      e.target.value = '';
    } else {
      const reader = new FileReader();
      reader.onload = () => {
        setCropDialogOpen(true);
      };
      reader.readAsBinaryString(files[0]);
      setCropImgSrc(URL.createObjectURL(files[0]));
      setFileObject(files[0]);
      e.target.value = '';
    }
  };

  const isDarkModeOn = useDarkModeStatus(getIsDarkModeOn);

  return (
    <>
      <ButtonsWrapper>
        <StyInput
          type="file"
          ref={hiddenFileInput}
          accept="image/png,image/jpeg"
          onChange={onChange}
        />
        <UploadButton
          disabled={isUploadDisabled}
          onClick={isUploadDisabled ? undefined : () => uploadHandleClick()}
          src={
            isDarkModeOn
              ? getImage('unacademy-ai/upload-photo-dark.svg')
              : getImage('unacademy-ai/upload-photo.svg')
          }
        />
      </ButtonsWrapper>
      {error && (
        <ErrorWrapper>
          <Image
            src="oneToOneLiveMentoring/errorExclamation.svg"
            width={Spacings.SPACING_6B}
            height={Spacings.SPACING_6B}
            alt="error"
          />
          <UploadMsg>{error}</UploadMsg>
        </ErrorWrapper>
      )}
      <ImageUploadDailog
        isCropDialogOpen={isCropDialogOpen}
        rotate={rotate}
        fileObj={fileObj}
        isUploading={isUploading}
        setCropDialogOpen={setCropDialogOpen}
        setImageRotate={setImageRotate}
        setCropper={setCropper}
        setIsUploading={setIsUploading}
        cropper={cropper}
        // setCropData={setCropData}
        setUploadedImageUrl={setUploadedImageUrl}
        setError={setError}
        isASDEnabled={isASDEnabled}
        goalUID={goalUID}
        cropImgSrc={cropImgSrc}
        setSignedUrl={setSignedUrl}
      />
      {showImageSizeErrorDialog && (
        <ImageSizeLimitDialog
          maxAttachmentSizeInKB={maxAttachmentSizeInKB}
          dialogState={showImageSizeErrorDialog}
          onCloseDialog={onImageSizeErrorDailogClose}
          imgComp={dialogImage('doubts20/imageSizeUploadError.svg')}
        />
      )}
    </>
  );
};

export default UnAIDoubtImageUpload;
